import React, { Component } from "react";

class Legal extends Component {
  render() {
    return (
      <h1 id="Legal">
        <div>
          <a href="https://drive.google.com/file/d/1x_dna8fcD-1JXoqaGVjOzYY5eSQU--LK/view?usp=sharing" target="_blank" rel="noopener noreferrer">Privacy</a>  <a href="https://drive.google.com/file/d/1Et3mJEXPDBBUum5fTq8yTyR2XEwv3108/view?usp=sharing" target="_blank" rel="noopener noreferrer">Terms</a>
        </div>
      </h1>
    );
  }
}

export default Legal;